/*
 * @Description:
 * @Date: 2024-12-13 17:06:19
 */
import {
  useInputColumn,
  useSelectColumn,
  useDatePickerColumn
} from 'xrk-components';
import { PAY_TYPE } from '@/common/constants/order';
import { PAY_PASSAGEWAY_MAPPING } from '@/common/constants/bank/index';
import { ORDER_PAY_STATUS_PAY_SUCCESS } from '@/views/asp-order/src/constants';

/** 手机号 */
export const phoneSearch = useInputColumn({
  label: '手机号',
  prop: 'phone',
  type: 'input',
  config: {
    type: 'tel',
    placeholder: '请输入'
  }
});

/** 所属园区 */
export const parkNameSearch = useInputColumn({
  prop: 'belongingPark',
  type: 'input',
  label: '所属园区',
  config: {
    placeholder: '请输入'
  }
});

/** 订单编号 */
export const orderNoSearch = useInputColumn({
  prop: 'orderNo',
  type: 'input',
  label: '订单编号',
  config: {
    placeholder: '请输入'
  }
});

/** 个体工商户名称 */
export const individualNameSearch = useInputColumn({
  prop: 'individualName',
  type: 'input',
  label: '个体工商户名称',
  config: {
    placeholder: '请输入'
  }
});

/** 终端服务人员 */
export const fullNameSearch = useInputColumn({
  prop: 'userName',
  type: 'input',
  label: '终端服务人员',
  config: {
    placeholder: '请输入'
  }
});

/** 项目名称 */
export const projectNameSearch = useInputColumn({
  prop: 'projectName',
  type: 'input',
  label: '项目名称',
  config: {
    placeholder: '请输入'
  }
});

/** 项目编码 */
export const projectNoSearch = useInputColumn({
  prop: 'projectCode',
  type: 'input',
  label: '项目编码',
  config: {
    placeholder: '请输入'
  }
});

/** 工业名称 */
export const entpNameSearch = useInputColumn({
  prop: 'industryName',
  type: 'input',
  label: '工业名称',
  config: {
    placeholder: '请输入'
  }
});

/** 服务商名称 */
export const aspNameSearch = useInputColumn({
  prop: 'aspName',
  type: 'input',
  label: '服务商名称',
  config: {
    placeholder: '请输入'
  }
});

/** 订单支付时间 */
export const orderPayTimeSearch = useDatePickerColumn({
  prop: 'orderPayTime',
  label: '订单支付时间',
  style: {
    width: '270px'
  },
  config: {
    type: 'daterange'
  }
});

/** 支付方式 */
export const payTypeSearch = useSelectColumn({
  prop: 'payType',
  label: '支付方式',
  config: {
    placeholder: '请选择',
    options: PAY_TYPE
  }
});

/** 支付通道 */
export const payPassagewayNameSearch = useSelectColumn({
  prop: 'payPassagewayCode',
  label: '支付通道',
  config: {
    placeholder: '请选择',
    options: PAY_PASSAGEWAY_MAPPING
  }
});

/** 支付状态 */
export const payStatusSearch = useSelectColumn({
  prop: 'payStatus',
  label: '支付状态',
  config: {
    placeholder: '请选择',
    options: ORDER_PAY_STATUS_PAY_SUCCESS
  }
});

/**
 * 服务费列表
 * individualProxyFee 个体税金及服务费订单
 */
export const getServiceSearch = orderNo => {
  return [
    { ...orderNoSearch, defaultValue: orderNo },
    individualNameSearch,
    parkNameSearch,
    { ...fullNameSearch, label: '经营者' },
    phoneSearch,
    entpNameSearch,
    aspNameSearch,
    projectNameSearch,
    projectNoSearch,
    orderPayTimeSearch,
    payStatusSearch,
    payPassagewayNameSearch,
    payTypeSearch
  ];
};
